var exports = {
  "k": "x2b2fbebb--689b3a--container",
};

module.exports = exports;
